import { IdentifierColumnType } from "./IdentifierColumnType";

/**
 * Mapping of identifier column types to their display names
 */
export const IDENTIFIER_TYPE_DISPLAY_NAMES: Record<
  IdentifierColumnType,
  string
> = {
  "EMAIL-ADDRESS": "Email Address",
  "EMPLOYEE-REFERENCE": "Employee Reference",
  "USER-ID": "User ID",
};

export const IDENTIFIER_TYPE_DISPLAY_NAMES_PLURAL: Record<
  IdentifierColumnType,
  string
> = {
  "EMAIL-ADDRESS": "Email Addresses",
  "EMPLOYEE-REFERENCE": "Employee References",
  "USER-ID": "User IDs",
};
